// @ts-nocheck
import * as React from "react";
import { Fish, Bird, FishSec } from "./Animals";
import anime from "animejs";
import LazyLoad from "vanilla-lazyload";

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

declare global {
    interface Window {
        drupalSettings: any
    }
    interface Document {
        lazyLoadInstance: any
    }
}

if (!document.lazyLoadInstance) {
    document.lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });
}

export const Fishes = () => {
    return (
        <div className='af-bg'>
            <div className='af-bg__fishes'>
                <Fish />
                <Fish />
                <Fish />
            </div>
        </div>
    )
}

export const Sky = () => {

    const animateClouds = (): void => {
        anime({
            targets: '.af-bg__cloud',
            translateX: 150,
            loop: true,
            easing: 'linear',
            duration: 17000,
            direction: 'alternate',
        });

        anime({
            targets: '.af-bg__cloud2',
            translateX: -50,
            loop: true,
            easing: 'linear',
            duration: 5000,
            direction: 'alternate',
        });

        anime({
            targets: '.af-bg__cloud3',
            translateX: 50,
            loop: true,
            easing: 'linear',
            duration: 5000,
            direction: 'alternate',
        });
    }

    const animateSun = () => {
        anime({
            targets: '.af-bg__sun',
            opacity: [0, 1],
            translateY: ['20vw', 0],
            easing: 'easeInBounce',
            duration: 10000,
        });
    }

    const animateLake = () => {
        anime({
            targets: '.af-bg__lake',
            translateX: '10vh',
            translateY: '0.5vw',
            loop: true,
            easing: 'linear',
            duration: 5000,
            direction: 'alternate',
        });
    }

    React.useEffect(() => {
        animateClouds()
        animateLake()
        animateSun()
        document.lazyLoadInstance.update();
    })

    return (
        <div className='af-bg'>
            <img className='af-bg__main' src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/cielo.jpg`} alt="" title="" />
            <div className='af-bg__sun'></div>
            <img className='af-bg__cloud' src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/nube1.png`} alt="" title="" />
            <img className='af-bg__cloud2' src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/nube2.png`} alt="" title="" />
            <img className='af-bg__cloud3' src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/nube3.png`} alt="" title="" />
            <img className='af-bg__lake' src={`/${THEMEURL}/sources/dist/assets/images/general/background/agua/lake.png`} alt="" title="" />
            <img className='parallax-effect af-bg__mountainL' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/montanaL.png`} alt="" title="" data-rellax-speed="0.05" />
            <img className='parallax-effect af-bg__mountainL2' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/montanaL2.png`} alt="" title="" data-rellax-speed="0.05" />
            <img className='parallax-effect af-bg__mountainL3' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/montanaL3.png`} alt="" title="" data-rellax-speed="0.05" />
            <img className='parallax-effect af-bg__mountainL4' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/montanaL4.png`} alt="" title="" data-rellax-speed="0.05" />
            <img className='parallax-effect af-bg__treeR' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/arbolR.png`} alt="" title="" data-rellax-speed="0.05" />
            <img className='parallax-effect af-bg__mountainR' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/montanaR.png`} alt="" title="" data-rellax-speed="0.1" />
            <img className='parallax-effect af-bg__mountainR2' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/montanaR2.png`} alt="" title="" data-rellax-speed="0.15" />
            <img className='parallax-effect af-bg__treeR2' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/arbolR2.png`} alt="" title="" data-rellax-speed="0.1" />
            <img className='parallax-effect af-bg__treeR3' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/arbolR3.png`} alt="" title="" data-rellax-speed="0.1" />
            <img className='parallax-effect af-bg__treeL' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/arbolL.png`} alt="" title="" data-rellax-speed="0.05" />
            <img className='parallax-effect af-bg__treeL2' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/arbolL2.png`} alt="" title="" data-rellax-speed="0.05" />
            <img className='parallax-effect af-bg__house' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/casita.png`} alt="" title="" data-rellax-speed="0.05" />
            <img className='parallax-effect af-bg__floor' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/terreno.png`} alt="" title="" data-rellax-speed="0.2" />
            <img className='parallax-effect af-bg__treeL3' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/arbolL3.png`} alt="" title="" data-rellax-speed="0.1" />
            <img className='parallax-effect af-bg__cactus' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/cactus.png`} alt="" title="" data-rellax-speed="0.2" />
            <Bird />
        </div>
    )
}

export const SkySec = ({ desk, mobile }: any) => {
    return (
        <div className='af-bg-solution'>
            <img className='af-bg-solution__full-bg' src={desk.url} alt={desk.alt} title={desk.alt} />
            {/* <Bird /> */}
        </div>
    )
}

export const Lake = () => {

    React.useEffect(() => {
        document.lazyLoadInstance.update();
    })

    return (
        <div className='af-bg'>
            <img className='lazy af-bg__back-water' data-src={`/${THEMEURL}/sources/dist/assets/images/general/background/agua/bg-water.jpg`} alt="" title="" />
            <img className='lazy af-bg__water-earth' data-src={`/${THEMEURL}/sources/dist/assets/images/general/background/agua/water-earth.png`} alt="" title="" />
            <img className='lazy af-bg__water-color' data-src={`/${THEMEURL}/sources/dist/assets/images/general/background/agua/water-color.png`} alt="" title="" />
            <img className='lazy af-bg__water-waves' data-src={`/${THEMEURL}/sources/dist/assets/images/general/background/agua/water-waves.png`} alt="" title="" />
            <FishSec />
            {/* <div className='af-bg__fishes'>
                <Fish />
                <Fish />
                <Fish />
            </div> */}
        </div>
    )
}